/* eslint-disable max-lines */
import { useTranslation } from 'react-i18next';

export const TermsAndConditions = () => {
  const { t } = useTranslation();

  return (
    <div className="w-full">
      <header className="bg-primary-bg text-center pb-4 pt-8 rounded-t-lg -mx-6 -mt-6 px-6">
        <h1 className="text-2xl font-bold">
          {t('termsAndConditions.title', 'Terms & Conditions')}
        </h1>
        <p className="text-sm">
          {t(
            'termsAndConditions.lastUpdated',
            'Last updated: December 05 2025'
          )}
        </p>
      </header>

      <div className="py-6">
        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.introductionTitle', '')}
          </h2>
          <p className="mt-2 leading-6">
            {t(
              'termsAndConditions.introductionText',
              `PLEASE READ THESE TERMS AND CONDITIONS CAREFULLY.`
            )}
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.applicableTermsTitle', '')}
          </h2>
          <p className="mt-2 leading-6">
            This terms of use agreement (this "agreement") (together with the
            documents referred to in it) is a legal agreement between you and
            Scriptix B.V., a company incorporated and registered in The
            Netherlands at the Chamber of Commerce under number: 75668475, whose
            statutory seat is at Oder 20, 2491DC, The Hague Netherlands ("we",
            "us" or "our"), for the use of our website: www.scriptix.io, web
            application: scriptix.app (collectively the "Scriptix Platform"). By
            using and/or registering to use{' '}
            <a href="https://scriptix.app" className="text-blue-500">
              the Scriptix Platform
            </a>
            , you must read, agree with, and accept all the terms and conditions
            contained in this agreement. This agreement is provided to you and
            concluded in English. You agree that any use by you of the Scriptix
            Platform shall constitute your acceptance of the agreement. We
            recommend that you store or print off a copy of the agreement
            (including all policies) for your records. If you do not agree to
            the terms of this agreement, please refrain from using the Scriptix
            Platform.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t(
              'termsAndConditions.applicableTermsTitle',
              '1. APPLICABLE TERMS'
            )}
          </h2>
          <p className="mt-2 leading-6">
            1.1 This agreement refers to the following additional terms, which
            also apply to your use of the Scriptix Platform: our{' '}
            <a
              href="https://app.scriptix.io/privacy-policy"
              className="text-blue-500"
            >
              Privacy Policy and Data Processing Policy
            </a>
            , which sets out the terms on which we process any personal data we
            collect from you, or that you provide to us. By using the Scriptix
            Platform, you consent to such processing, and you warrant that all
            data provided by you is accurate.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t(
              'termsAndConditions.accessingPlatformTitle',
              '2. ACCESSING THE SCRIPTIX PLATFORM AND USING THE SCRIPTIX SERVICES'
            )}
          </h2>
          <p className="mt-2 leading-6">
            2.1 We have developed the Scriptix Platform, using AI technology to
            provide the following services: (a) automated transcription of
            audio/video files uploaded to the Scriptix Platform; ("Scriptix");
            (b) automated machine translation of files processed by Scriptix or
            uploaded to Scriptix; (c) editors for Transcription and Subtitles
            that allows users to search, verify and correct the content of their
            Scriptix output (the "Scriptix Editor"); (d) the Scriptix API
            (https://apidocs.scriptix.io/); (e) a variety of methods for
            exporting and sharing the contents of Scriptix; (f) forced alignment
            (g) automated summarization and meeting minutes generation using
            LLMs; (h) custom models for speech recognition and machine
            translation. (Together the "Scriptix Services").
          </p>
          <p className="mt-2 leading-6">
            2.2 In consideration of you agreeing to abide by the terms of this
            agreement, we hereby grant to you a non-exclusive, non-transferable,
            licence to use the Scriptix Platform and the Scriptix Services on
            the terms of this agreement. To access and use the Scriptix Services
            you must sign up with your name, email address and password to
            create an account ("Account"). We discourage generic account names
            and we actively monitor concurrent Account usage. You may log into
            your Account on multiple devices but you shall not be able to access
            and use the Scriptix Services via the same Account from multiple
            devices at the same time. Dependent on the tier of your Account (as
            detailed at clause 3.3) you may be authorized to have more than 3
            users ("Seat") per your Account. The number of Seats per Account
            shall be determined by your tier and if there are multiple Seats
            allowed via your Account, each Seat shall need to be a named
            individual. The original Account holder shall be the lead Seat
            (admin) until otherwise organized by you and shall be able to add a
            specified number of other Seats (in accordance with the selected
            tier). Seats may be transferred to new users at any time but shall
            always be for named individuals and not a generic Seat used by
            multiple individuals concurrently. Sharing of log-in details with
            any other user is strictly prohibited in accordance with clause 2.6.
          </p>
          <p className="mt-2 leading-6">
            2.3 Access to the Scriptix Platform is permitted on a temporary
            basis and we reserve the right to withdraw or amend the services or
            functionality that we provide on the Scriptix Platform without
            notice. We will not be liable if for any reason the Scriptix
            Platform is unavailable at any time or for any period.
          </p>
          <p className="mt-2 leading-6">
            2.4 From time to time, we may restrict access to some parts of the
            Scriptix Platform, or the entire Scriptix Platform, to users who
            have registered with us. We will use reasonable endeavours to fix
            issues and bugs in the Scriptix Platform as quickly as we can.
          </p>
          <p className="mt-2 leading-6">
            2.5 If you choose, or you are provided with, a user identification
            code, password or any other piece of information as part of our
            security procedures, you must treat such information as
            confidential, and you must not disclose it to any third party. We
            have the right to disable any user identification code or password,
            whether chosen by you or allocated by us, at any time, if in our
            opinion you have failed to comply with any of the provisions of this
            agreement.
          </p>
          <p className="mt-2 leading-6">
            2.6 You must not misuse the Scriptix Platform by knowingly
            introducing viruses, Trojans, worms, logic bombs or other material
            which is malicious or technologically harmful. You must not attempt
            to gain unauthorized access to the Scriptix Platform, the server on
            which the Scriptix Platform is stored or any server, computer or
            database connected to the Scriptix Platform. You must not attack the
            Scriptix Platform via a denial-of-service attack or a distributed
            denial-of service attack.
          </p>
          <p className="mt-2 leading-6">
            2.7 If you breach clause 2.6, you will be committing a criminal
            offence. We will report any such breach to the relevant law
            enforcement authorities, and we will cooperate with those
            authorities by disclosing your identity to them. In the event of
            such a breach, we reserve the right to immediately cease your right
            to use the Scriptix Platform.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.bundlesTitle', '3. BUNDLES AND PARTNERS')}
          </h2>
          <p className="mt-2 leading-6">
            3.1 Bundles. Scriptix offers monthly unlimited subscription bundles
            under a fair use policy. Prices, included services and fair use caps
            per subscription are as follows:
          </p>
          <div className="overflow-x-auto mt-4">
            <table className="min-w-full border-collapse border border-current">
              <thead>
                <tr className="bg-opacity-10 dark:bg-opacity-5">
                  <th className="border border-current px-4 py-2 text-left">
                    Plan
                  </th>
                  <th className="border border-current px-4 py-2 text-left">
                    Price/Month
                  </th>
                  <th className="border border-current px-4 py-2 text-left">
                    Included Services
                  </th>
                  <th className="border border-current px-4 py-2 text-left">
                    Fair use & limits
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-current px-4 py-2">Bronze</td>
                  <td className="border border-current px-4 py-2">€119.00</td>
                  <td className="border border-current px-4 py-2">
                    Batch speech to text
                    <br />
                    UI & API access
                    <br />3 seats
                  </td>
                  <td className="border border-current px-4 py-2">
                    Up to 1,000 minutes per month speech recognition.
                  </td>
                </tr>
                <tr>
                  <td className="border border-current px-4 py-2">Silver</td>
                  <td className="border border-current px-4 py-2">€479.00</td>
                  <td className="border border-current px-4 py-2">
                    Batch & Realtime speech to text
                    <br />
                    UI & API access
                    <br />
                    10 seats
                    <br />
                    Machine Translation
                    <br />
                    Meeting Minutes
                    <br />
                    Summarization
                    <br />
                    Priority processing
                  </td>
                  <td className="border border-current px-4 py-2">
                    5,000 minutes per month speech recognition, 2 million
                    translated characters per month, 20 meeting
                    minutes/summaries exports/month.
                  </td>
                </tr>
                <tr>
                  <td className="border border-current px-4 py-2">Gold</td>
                  <td className="border border-current px-4 py-2">€1,199.00</td>
                  <td className="border border-current px-4 py-2">
                    Batch & Realtime speech to text
                    <br />
                    UI & API access
                    <br />
                    Unlimited seats
                    <br />
                    Machine Translation
                    <br />
                    Meeting Minutes
                    <br />
                    Summarization
                    <br />
                    Priority processing,
                    <br />
                    Dedicated SLA
                    <br />
                    Roadmap access
                  </td>
                  <td className="border border-current px-4 py-2">
                    15,000+ minutes per month speech recognition, 6 million
                    translated characters per month, 200 meeting
                    minutes/summaries exports/month, 1 custom STT model and
                    translation glossaries.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <p className="mt-2 leading-6">
            3.3 If your usage puts system integrity at risk i.e. you upload a
            large volume of files in a short period of time, Scriptix reserves
            the right to throttle your access to the service to ensure system
            integrity for all our customers.
          </p>
          <p className="mt-2 leading-6">
            3.4 We design our tiers to cover typical monthly use for 80-90% of
            our customers. To ensure service quality, excessive or abnormal use
            may trigger rate limiting after 2x fair use thresholds. Continued
            excessive use, i.e. for 3 consecutive months/payment terms, triggers
            scaling to a higher subscription tier. You will be notified in
            writing, via email, of our intention to scale your subscription to a
            higher tier allowing a 30-day period to lower your usage of the
            Scriptix Platform.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.paymentTitle', '4. PAYMENT')}
          </h2>
          <p className="mt-2 leading-6">
            4.1 If you wish to subscribe for a subscription, you:
          </p>
          <p className="mt-2 leading-6">
            (a) agree to pay to us the relevant Fee as set out on the{' '}
            <a
              href="https://app.scriptix.io/subscribe"
              className="text-blue-500"
            >
              Pricing Page
            </a>{' '}
            or{' '}
            <a
              href="https://scriptix.app/register-with-subscription"
              className="text-blue-500"
            >
              Registering Page
            </a>{' '}
            and (b) agree and undertake to pay to us (without any deduction) the
            relevant Fee in advance in full (in EUR, GBP, USD or the equivalent
            in your local currency based on the conversion rate at the time of
            payment) and authorize us to collect the full fee from you each
            month until you cancel your subscription in accordance with clauses
            5.3 to 5.6 below; and (c) acknowledge that, subject to clause 5,
            that the relevant Fees are non-refundable.
          </p>
          <p className="mt-2 leading-6">
            4.2 We reserve our rights to amend the fees at any time. However, we
            shall notify you in writing of any change in the Fees and any such
            change shall take effect at the beginning of the new month.
          </p>
          <p className="mt-2 leading-6">
            4.3 We may offer promotional offers from time to time which may
            include promo codes or Account credits, and which may be subject to
            expiration dates and may only be applicable to selected users of the
            Scriptix Platform. We reserve the right to remove Account credits
            from your Account or end a promotional offer without notice if we
            believe, at our sole discretion, you are not acting in good faith in
            relation to the terms of the promotion.
          </p>
          <p className="mt-2 leading-6">
            4.7 Payments will be processed by a third-party payment processor,
            Mollie, in accordance with its standard terms and conditions:{' '}
            <a
              href="https://www.mollie.com/en/user-agreement"
              className="text-blue-500"
            >
              https://www.mollie.com/en/user-agreement.
            </a>
          </p>
          <p className="mt-2 leading-6">You hereby give consent:</p>
          <p className="mt-2 leading-6">
            (a) to us sending you electronic communications (including via email
            and text) in relation to upcoming and successful payments managed
            via the Scriptix Platform; and (b) for the payment processor to
            access your bank account which is nominated by you from time to
            time, and to either deduct or deposit the applicable amount, less
            any fee which may apply. See the{' '}
            <a
              href="https://app.scriptix.io/subscribe"
              className="text-blue-500"
            >
              Pricing Page
            </a>{' '}
            or{' '}
            <a
              href="https://scriptix.app/register-with-subscription"
              className="text-blue-500"
            >
              Registering Page
            </a>{' '}
            for more information about applicable Fees.
          </p>
          <p className="mt-2 leading-6">
            You acknowledge and agree that when using the Mollie service on the
            Scriptix Platform, you will comply with Mollie's end user licence
            agreement in respect to your use of the Mollie service. You also
            acknowledge that Mollie's privacy policy at:{' '}
            <a
              href="https://www.mollie.com/en/privacy"
              className="text-blue-500"
            >
              https://www.mollie.com/en/privacy
            </a>{' '}
            shall apply to Mollie's processing of any personal information you
            submit to Mollie via the Scriptix Platform. We shall not be liable
            to any person if Mollie or any other payment processor is not able
            to deduct or deposit any amount due to insufficient funds or
            incorrect bank account details.
          </p>
          <p className="mt-2 leading-6">
            4.8 If the credit card details you have provided us with via your
            Account are invalid at the point of us charging you for the Fees
            owed to us, we shall inform you by email. We will make every effort
            to contact you by email (to the address used to set up your Account)
            if your card payment fails.
          </p>
          <p className="mt-2 leading-6">
            4.9 If your payment fails, after notifying you we shall continue to
            attempt to take payment up to three (3) times over a period of nine
            (9) days to allow you to update your payment details before we shall
            suspend your Account and your access to the Scriptix Platform and
            the Scriptix Services.
          </p>
          <p className="mt-2 leading-6">
            4.10 If the card details are not updated after 9 days, we reserve
            the right to permanently delete your Account and all data, files and
            Scriptix results held within.
          </p>
          <p className="mt-2 leading-6">
            4.11 If you prefer to receive an invoice and wire transfer the
            required amount for your subscription to us directly get in touch
            via:{' '}
            <a href="mailto:info@scriptix.io" className="text-blue-500">
              info@scriptix.io
            </a>{' '}
            and your account will be set-up by us from our Backoffice system
            directly.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t(
              'termsAndConditions.termAndTerminationTitle',
              '5. TERM & TERMINATION'
            )}
          </h2>
          <p className="mt-2 leading-6">
            5.1 These terms & conditions enter into effect upon successful
            registration of your account and payment of the first term. It will
            then remain in effect for 1 year.
          </p>
          <p className="mt-2 leading-6">
            5.2 After 1 year, the agreement will be tacitly renewed for the same
            duration of 1 year.
          </p>
          <p className="mt-2 leading-6">
            5.3 The agreement can be terminated after the initial contract
            period observing a 1-month notice period.
          </p>
          <p className="mt-2 leading-6">
            Upon termination or expiry for any reason:
          </p>
          <p className="mt-2 leading-6">
            (a) all rights granted to you under this agreement shall cease; (b)
            you must cease all activities authorised by this agreement; and (c)
            you must immediately delete your Account and cease using the
            Scriptix Platform and certify to us that you have done so.
          </p>
          <p className="mt-2 leading-6">
            5.4 Please note once you have deleted your Account we shall not be
            able to recover your files/results generated on the Scriptix
            Platform, so please download all transcripts before you delete your
            Account.
          </p>
          <p className="mt-2 leading-6">
            5.5 We reserve the right to delete your Account on termination of
            this agreement and for non-payment of the Fees owed in accordance
            with clauses 3 and 4 of this agreement.
          </p>
          <p className="mt-2 leading-6">
            5.6 Any provision of this agreement that expressly or by implication
            is intended to come into or continue in force on or after
            termination or expiry of this agreement shall remain in full force
            and effect.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t(
              'termsAndConditions.contentConfidentialityTitle',
              '6. YOUR CONTENT AND CONFIDENTIALITY'
            )}
          </h2>
          <p className="mt-2 leading-6">
            6.1 Audio/visual and textual content submitted to us by you (and any
            intellectual property rights in it) is owned by you or your
            licensor. You grant Scriptix a non-exclusive license to use that
            material solely for the purpose of providing the Scriptix Services
            and creating Scriptix output. Scriptix output (and any intellectual
            property rights in them) are owned by you, subject to you having
            paid the Fees required under this agreement.
          </p>
          <p className="mt-2 leading-6">
            6.2 Scriptix shall have no obligations with respect to the material
            which you submit other than to perform the Scriptix Services as set
            out in this agreement. You are solely responsible for such material.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t(
              'termsAndConditions.indemnitiesTitle',
              '7. YOUR INDEMNITIES AND UNDERTAKINGS'
            )}
          </h2>
          <p className="mt-2 leading-6">
            7.1 You agree that when using the Scriptix Platform you will comply
            with all applicable laws and this agreement. In particular, but
            without limitation, you agree not to:
          </p>
          <p className="mt-2 leading-6">
            (a) use the Scriptix Platform in any unlawful manner or in a manner
            which promotes or encourages illegal activity; or (b) breach any
            law, statute, contract, or regulation; (c) act in a manner that is
            obscene, defamatory, libellous, unlawfully threatening or unlawfully
            harassing; (d) provide false, inaccurate or misleading information;
            (e) use an anonymising proxy; or (f) attempt to gain unauthorised
            access to the Scriptix Platform or any networks, servers or computer
            systems connected to the Scriptix Platform. (together the
            "Restricted Activities")
          </p>
          <p className="mt-2 leading-6">
            7.2 Except as expressly set out in this agreement or as permitted by
            any local law, you undertake:
          </p>
          <p className="mt-2 leading-6">
            (a) not to rent, lease, sub-license, loan, translate, merge, adapt,
            vary or modify the Scriptix Platform or your access to the Scriptix
            Platform; (b) not to engage in any of the Restricted Activities, nor
            control an account that is linked to any of the Restricted
            Activities; (c) not to make alterations to, or modifications of, the
            whole or any part of the Scriptix Platform nor permit the Scriptix
            Platform or any part of it to be combined with, or become
            incorporated in, any other programs or websites (save for in
            accordance with proper use of Scriptix API); (d) not to disassemble,
            de-compile, reverse engineer or create derivative works based on the
            whole or any part of the Scriptix Platform; (e) to include our
            copyright notice on all entire and partial copies of the Scriptix
            Platform in any form; or (f) not to provide, or otherwise make
            available, the Scriptix Platform in any form, in whole or in part
            (including, but not limited to, program listings, object and source
            program listings, object code and source code) to any person without
            prior written consent from us.
          </p>
          <p className="mt-2 leading-6">
            7.3 Notwithstanding clause 7.1 and 7.2, you agree to indemnify us in
            full and on demand from and against any loss, damage, costs, or
            expenses which we suffer or incur directly or indirectly as a result
            of your use of the Scriptix Platform, otherwise than in accordance
            with this agreement or any applicable laws.
          </p>
          <p className="mt-2 leading-6">
            7.4 You warrant to us that all the information you provide to us is
            true and accurate to the best of your knowledge.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t(
              'termsAndConditions.intellectualPropertyTitle',
              '8. INTELLECTUAL PROPERTY RIGHTS'
            )}
          </h2>
          <p className="mt-2 leading-6">
            8.1 We are the owner of all intellectual property rights in the
            Scriptix Platform and in the material published on it. Those works
            are protected by copyright laws and treaties around the world. All
            such rights are reserved.
          </p>
          <p className="mt-2 leading-6">
            8.2 The trademarks, service marks, and logos ("Trade Marks")
            contained on the Scriptix Platform are owned by us, our group
            companies or third party partners of us. You cannot use, copy, edit,
            vary, reproduce, publish, display, distribute, store, transmit,
            commercially exploit or disseminate the Trade Marks without the
            prior written consent of us, the relevant group company or the
            relevant third party partner of us.
          </p>
          <p className="mt-2 leading-6">
            8.3 You must not modify the paper or digital copies of any materials
            you have printed off or downloaded in any way, and you must not use
            any illustrations, photographs, video or audio sequences or any
            graphics separately from any accompanying text.
          </p>
          <p className="mt-2 leading-6">
            8.4 Our status (and that of any identified contributors) as the
            authors of content on the Scriptix Platform must always be
            acknowledged.
          </p>
          <p className="mt-2 leading-6">
            8.5 You must not use any part of the content on the Scriptix
            Platform for commercial purposes without obtaining a licence to do
            so from us or our licensors.
          </p>
          <p className="mt-2 leading-6">
            8.6 If you print off, copy, or download any part of the Scriptix
            Platform in breach of this agreement, your right to use the Scriptix
            Platform will cease immediately and you must, at our option, return
            or destroy any copies of the materials you have made.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t(
              'termsAndConditions.callRecordingTitle',
              '9. CALL RECORDING CONSENT'
            )}
          </h2>
          <p className="mt-2 leading-6">
            9.1. You acknowledge and agree that you will only upload content to
            the Scriptix Platform, that may be used by Scriptix in the
            performance of the Scriptix Services, that has been recorded in
            compliance with all applicable laws, including but not limited to:
            the General Data Protection Regulation (EU) (2016/679) and all
            equivalent applicable local laws in the jurisdiction in which you
            record any content you upload.
          </p>
          <p className="mt-2 leading-6">
            9.2 Please note that in the United Kingdom, Ireland, Germany,
            Canada, Australia and a number of US states the consent of every
            party to a phone call or conversation is required in order to make
            the recording lawful, this is called "two-party consent". Therefore,
            whether a jurisdiction requires one or two-party consent to call
            recording, it is best practice to obtain consent from all parties on
            the call.
          </p>
          <p className="mt-2 leading-6">
            9.3 We accept no responsibility or liability for obtaining consent.
            It is the sole responsibility of the person making and processing
            the telephone call on the Scriptix Platform to ensure compliance
            with all local laws. You acknowledge and accept all responsibility
            and liability for all calls and recordings processed via your
            Account on the Scriptix Platform.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.dataTitle', '10. PROVISIONS REGARDING DATA')}
          </h2>
          <p className="mt-2 leading-6">
            10.1 Scriptix Platform can be used to (temporarily) store data. By
            default Scriptix observes a 1-year retention period after which any
            data will be deleted from our servers.
          </p>
          <p className="mt-2 leading-6">
            10.2 Data that has been uploaded/streamed to Scriptix Platform will
            be deleted immediately after it has been processed if technically
            set-up through our API-platform by you as such.
          </p>
          <p className="mt-2 leading-6">
            10.3 When using our Transcript and/or Subtitle Editor(s), you can
            delete your files (uploaded content and generated results) when
            processed. Upon selecting this option your data will be deleted from
            our servers.
          </p>
          <p className="mt-2 leading-6">
            10.4 By default, no data uploaded to Scriptix Platform will be used
            for training our algorithms, this will only be the case after opt-in
            by you.
          </p>
          <p className="mt-2 leading-6">
            10.5 With Scriptix Platform personal data can be processed. In this
            case Partner acts as liable party and Scriptix as processor. View
            our Data Processing Policy page and our Trust Center for more
            information.
          </p>
          <p className="mt-2 leading-6">
            10.6 Scriptix has implemented the following technical and
            organizational security measures:
          </p>
          <ul className="list-disc pl-12 mt-2 leading-6 text-sm">
            <li>Access control by means of usernames, passwords and 2FA.</li>
            <li>Automatic logging of all actions regarding personal data.</li>
            <li>Encryption of digital records holding personal data.</li>
            <li>Organizational measures for access security.</li>
            <li>
              We use secure connections through TLS (Transport Layer Security)
              to encrypt all information between Partner, end users, and our
              website or services when accessing personal data.
            </li>
            <li>A secured internal network.</li>
          </ul>
          <p className="mt-2 leading-6">
            10.7 Scriptix guarantees that material uploaded to and processed
            with Scriptix Platform will only be stored on systems that are
            physically located within the European Union. We process data with
            our cloud provider Microsoft Azure in Western-Europe.
          </p>
          <p className="mt-2 leading-6">
            10.8 In case a party involved sends a request to Scriptix for
            inspection, addition, modification or shielding, as meant in
            articles 15 to 22 of the General Data Protection Regulation,
            Scriptix will forward the request to Partner who will further handle
            it. Scriptix is authorized to inform the party involved thereof.
          </p>
          <p className="mt-2 leading-6">
            10.9 Scriptix is authorized to make statistical analyses of end user
            behavior when using Scriptix Speech to Text, however only in an
            aggregated manner and without using profiles or registrations from
            individual users.
          </p>
          <p className="mt-2 leading-6">
            10.10 Scriptix never uses data that has been uploaded and/or
            manually corrected with our Transcript and Subtitle editors to
            improve its algorithms unless we have written consent from you to do
            so.
          </p>
          <p className="mt-2 leading-6">
            10.11 Using our speech recognition custom models and machine
            translation glossaries functionalities constitutes an opt-in from
            you allowing Scriptix to use data uploaded to these functionalities.
          </p>
          <p className="mt-2 leading-6">
            10.12 You can delete content you have uploaded to Scriptix Platform
            as well as the output generated by Scriptix Platform, your profile
            and organization at any time.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.changesTitle', '11. CHANGES TO THESE TERMS')}
          </h2>
          <p className="mt-2 leading-6">
            11.1 We may revise this agreement (or any of the documents referred
            to in this agreement) by amending this page. Please check this page
            from time to time to take notice of any changes we made, as they are
            binding on you.
          </p>
          <p className="mt-2 leading-6">
            11.2 Changes to pricing will be communicated at least 30 days before
            renewal of this agreement. If you do not wish to accept a change or
            addition, you can terminate the agreement until the date these
            changes take effect. Use of Scriptix Platform after the date of
            effect shall constitute your acceptance of the changed or added-to
            terms and conditions.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.duplicateTitle', '12. DUPLICATE ACCOUNTS')}
          </h2>
          <p className="mt-2 leading-6">
            We reserve the right to refuse the creation of duplicate accounts
            for the same user. In a case where duplicate accounts are detected,
            we reserve the right to close or merge these duplicate accounts
            without notification.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.eligibilityTitle', '13. ELIGIBILITY')}
          </h2>
          <p className="mt-2 leading-6">
            13.1 To be eligible for the Scriptix Platform, you must (a) be at
            least 18 years old (b) a company and (c) agree to the terms of this
            agreement.
          </p>
          <p className="mt-2 leading-6">
            13.2 You undertake that your login may only be used by you and a
            login shared by multiple people is not permitted.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.warrantyTitle', '14. NO WARRANTY')}
          </h2>
          <p className="mt-2 leading-6">
            14.1 Use of the Scriptix Platform is at your own risk. The Scriptix
            Platform is provided on an "as is" basis. We do not warrant or
            guarantee that the Scriptix Platform and all or part of its contents
            will always generate 100% accurate results, will be always available
            or that its use will not be interrupted.
          </p>
          <p className="mt-2 leading-6">
            14.2 You acknowledge that the Scriptix Platform may not be free of
            bugs or errors, and you agree that the existence of any minor errors
            shall not constitute a breach of this agreement.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.liabilityTitle', '15. OUR LIABILITY')}
          </h2>
          <p className="mt-2 leading-6">
            15.1 Nothing in this agreement excludes or limits our liability for
            death or personal injury arising from our negligence, or our fraud
            or fraudulent misrepresentation, or any other liability that cannot
            be excluded or limited by Dutch law.
          </p>
          <p className="mt-2 leading-6">
            15.2 To the extent permitted by law, we exclude all conditions,
            warranties, representations or other terms which may apply to the
            Scriptix Platform or any content on it, whether express or implied.
          </p>
          <p className="mt-2 leading-6">
            15.3 Subject to clause 15.1, we will not be liable to any user for
            any loss or damage, whether in contract, tort (including
            negligence), breach of statutory duty, or otherwise, even if
            foreseeable, arising under or in connection with:
          </p>
          <p className="mt-2 leading-6">
            (a) use of, or inability to use, the Scriptix Platform or the
            Scriptix Services; or (b) use of or reliance on any content
            displayed on the Scriptix Platform.
          </p>
          <p className="mt-2 leading-6">
            15.4 We will not be liable for any loss or damage caused by a virus,
            distributed denial-of-service attack, or other technologically
            harmful material that may infect your computer equipment, computer
            programs, data or other proprietary material due to your use of the
            Scriptix Platform or to your downloading of any content on it, or on
            any website linked to it.
          </p>
          <p className="mt-2 leading-6">
            15.5 We assume no responsibility for the content of websites linked
            on the Scriptix Platform. Such links should not be interpreted as
            endorsement by us of those linked websites. We will not be liable
            for any loss or damage that may arise from your use of them.
          </p>
          <p className="mt-2 leading-6">
            15.6 Subject to clause 15.1, our maximum aggregate liability under
            or in connection with this agreement, or any collateral contract,
            whether in contract, tort (including negligence) or otherwise, shall
            in all circumstances be limited to a sum equal to €100 or the amount
            you paid to us in fees in the previous 12 calendar months, whichever
            is greater.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t(
              'termsAndConditions.transferTitle',
              '16. TRANSFER OF RIGHTS AND OBLIGATIONS'
            )}
          </h2>
          <p className="mt-2 leading-6">
            16.1 This agreement is binding on you and us and on our respective
            successors and assignees.
          </p>
          <p className="mt-2 leading-6">
            16.2 You may not transfer, assign, charge or otherwise dispose of
            this agreement, or any of your rights or obligations arising under
            it, without our prior written consent.
          </p>
          <p className="mt-2 leading-6">
            16.3 We may assign, charge, novate or otherwise dispose of this
            agreement without our prior written consent.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.generalTitle', '17. GENERAL TERMS')}
          </h2>
          <p className="mt-2 leading-6">
            <strong>Communications</strong>
          </p>
          <p className="mt-2 leading-6">
            17.1 We are required to provide certain information to you in
            writing. By accepting this agreement, you agree that we can
            communicate with you electronically either by email or by posting
            notices on the Scriptix Platform.
          </p>
          <p className="mt-2 leading-6">
            <strong>Entire Agreement</strong>
          </p>
          <p className="mt-2 leading-6">
            17.2 This agreement and any document expressly referred to in it
            constitutes the whole agreement between us and supersedes any
            previous discussions, correspondence, arrangements or understandings
            between us.
          </p>
          <p className="mt-2 leading-6">
            <strong>Law and Jurisdiction</strong>
          </p>
          <p className="mt-2 leading-6">
            17.3 This agreement and any dispute or claim arising out of or in
            connection with it or its subject matter or formation (including
            non-contractual disputes or claims) shall be governed by and
            construed in accordance with the law of The Netherlands.
          </p>
          <p className="mt-2 leading-6">
            17.4 Any dispute or claim arising out of or in connection with this
            agreement will be subject to the exclusive jurisdiction of the
            courts of The Netherlands.
          </p>
        </section>

        <section className="mb-6">
          <h2 className="text-xl font-semibold ">
            {t('termsAndConditions.companyInfoTitle', '18. COMPANY INFO')}
          </h2>
          <ul className="mt-2 leading-6 list-inside">
            <li>
              <strong>Company Name:</strong> Scriptix B.V.
            </li>
            <li>
              <strong>Company Address:</strong> Oder 20, 2491DC, The Hague,
              Netherlands
            </li>
            <li>
              <strong>Company Account Number:</strong> NL 67 INGB 0008200261
            </li>
            <li>
              <strong>Company BIC Number:</strong> INGBNL2A
            </li>
            <li>
              <strong>Company Tax Number:</strong> NL860357053B01
            </li>
            <li>
              <strong>Chamber of Commerce Registration:</strong> 75668475
            </li>
            <li>
              <strong>Email:</strong>{' '}
              <a href="mailto:info@scriptix.io" className="text-blue-500">
                info@scriptix.io
              </a>
            </li>
            <li>
              <strong>Contact Form:</strong>{' '}
              <a
                href="https://www.scriptix.io/contact"
                className="text-blue-500"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://www.scriptix.io/contact
              </a>
            </li>
          </ul>
        </section>
      </div>

      <footer className="bg-opacity-10 pt-8 dark:bg-opacity-5 text-center py-3 rounded-b-lg -mx-6 -mb-6 px-6 border-t border-current border-opacity-20">
        <p className="text-sm">
          {t(
            'termsAndConditions.footer',
            'For any questions, contact us at support@scriptix.io.'
          )}
        </p>
      </footer>
    </div>
  );
};
